import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './useClassifierFormLabelTranslation.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'classifier-form-label'
);
addTranslations(translations);

export const useClassifierFormLabelTranslation = useTranslation;
